import {sleep} from 'lib/utilities';
import Bus, {EventMap} from 'lib/bus';

interface BusEvents extends EventMap {
    change: [boolean];
}

export default function Flag() {
    const bus = new Bus<BusEvents>()
    let state = false;

    function toggle(): boolean {
        set(! state);

        return state;
    }

    function set(value: boolean) {
        if (value !== state) {
            state = value;
            bus.emit('change', state);
        }
    }

    function setTrue() {
        set(true);
    }

    function setFalse() {
        set(false);
    }

    function isTrue() {
        return state;
    }

    function isFalse() {
        return ! state;
    }

    async function setTrueUntil(promise: Promise<any>) {
        setTrue();

        await promise;

        setFalse();
    }

    async function setTrueFor(timeMs: number) {
        await setTrueUntil(sleep(timeMs));
    }

    return {
        on: bus.on,
        off: bus.on,
        once: bus.once,
        toggle,
        setTrue,
        setFalse,
        setTrueUntil,
        setTrueFor,
        isTrue,
        isFalse
    }
}
